function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0.458332938 0 11 0 11 10 0.458332938 10"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "0 0 7.66680029 0 7.66680029 10 0 10"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Mobile-default",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "iPhone-11",
  transform: "translate(-56.000000, -566.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-11",
  transform: "translate(56.000000, 566.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 12,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  transform: "translate(3.000000, 7.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(9.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.458381229,2.34 C0.453511799,1.468 0.70324398,0.765 1.19018695,0.362 C1.5240907,0.084 1.94494856,0.006 2.51258493,0 L5.67562735,0.002 C7.24149681,0.002 8.44633285,1.048 8.45815861,3.247 L8.45815861,6.845 C8.46581057,8.268 7.95452045,9.017 7.52392374,9.396 C7.06758861,9.798 6.47004002,9.991 5.6978876,10 L2.54527968,10 C1.83086477,10 0.469511354,9.998 0.458381229,8.002 C0.455598698,7.451 0.780459223,7.007 1.16444854,7.002 C1.51643874,6.997 1.80582199,7.263 1.84964686,7.999 L5.68606184,8.006 C6.36221694,7.999 7.07176241,7.835 7.06689298,6.86 L7.06689298,3.263 C7.06132792,2.13 6.3211746,1.997 5.67562735,2 L1.84964686,1.999 L1.84964686,2.323 C1.84964686,2.876 1.53800336,3.327 1.15401404,3.331 C0.772807262,3.331 0.46116376,2.889 0.458381229,2.34 Z",
  id: "Fill-1",
  fill: "#FFFFFF",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-6"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.30427675,3.331 C7.68548677,3.331 7.99713292,2.889 7.99998534,2.34 C8.00478494,1.468 7.75505064,0.765 7.26810354,0.362 C6.93419695,0.084 6.51333553,0.006 5.94569433,0 L2.78262508,0.002 C1.21674232,0.002 0.0118960594,1.048 7.02011546e-05,3.247 L7.02011546e-05,6.845 C-0.00758182476,8.268 0.503712634,9.017 0.934313001,9.396 C1.390652,9.798 1.98820566,9.991 2.76036464,10 L5.91299931,10 C6.62742028,10 7.98878525,9.998 7.99998534,8.002 C8.00269803,7.451 7.67783474,7.007 7.29384217,7.002 C6.94184898,6.997 6.65246327,7.263 6.60863803,7.999 L2.7721905,8.006 C2.09602966,7.999 1.38647817,7.835 1.39134764,6.86 L1.39134764,3.263 C1.39691275,2.13 2.13707235,1.997 2.78262508,2 L6.60863803,1.999 L6.60863803,2.323 C6.60863803,2.876 6.92028418,3.327 7.30427675,3.331",
  id: "Fill-4",
  fill: "#FFFFFF",
  mask: "url(#mask-4)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M12.9694,5 C12.9694,4.448 12.6707333,4 12.3027333,4 L5.63606667,4 C5.26806667,4 4.9694,4.448 4.9694,5 C4.9694,5.552 5.26806667,6 5.63606667,6 L12.3027333,6 C12.6707333,6 12.9694,5.552 12.9694,5",
  id: "Fill-7",
  fill: "#FFFFFF"
})))));

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.1c455e32.svg";
export { ForwardRef as ReactComponent };